import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import LoadingButton from '@mui/lab/LoadingButton'
import LoginIcon from '@mui/icons-material/Login'
import { Error, Spinner } from '../../common/Error';
import Hero from '../../common/Hero'
import {
  doLogin,
  selectUser,
} from './authSlice';

export const Login = () => {
  const dispatch = useDispatch();
  const email = localStorage.getItem('email')
  const user = useSelector(selectUser);
  const { loading, error, success } = useSelector((state) => state.auth.login)
  
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required')
      .email('Email is invalid'),
    password: Yup.string()
      .required('Password is required')
      .min(4, 'Password must be at least 4 characters')
      .max(32, 'Password must not exceed 32 characters'),
  })
  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      email: (email === undefined || email === null) ? '' : email,
      password: ''
    },
    resolver: yupResolver(validationSchema)
  })

  const navigate = useNavigate();
  //console.log('[Login] user =', user)
  //console.log('[Login] error =', error)
  useEffect(() => {
    if (success || user) {
      const next = localStorage.getItem('next')
        ? localStorage.getItem('next')
        : '/rooms'
      //console.log('[Login] next =', next)
      localStorage.removeItem('email')
      localStorage.removeItem('next')
      localStorage.removeItem('to')
      navigate(next);
    }
  }, [navigate, user])

  const submitForm = (data) => {
    data.email = data.email.toLowerCase()
    dispatch(doLogin(data))
  }

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Hero />
        <Typography component="h1" variant="h6">
          Log in to Babel Chat
        </Typography>
        <Box component='form' noValidate='noValidate' onSubmit={handleSubmit(submitForm)}>
          <TextField
            id='email'
            autoComplete='email'
            name='email'
            {...register('email')}
            required
            fullWidth
            label='Email'
            margin='normal'
            disabled={email !== undefined && email !== null}
            error={errors.email ? true : false}
            helperText={errors.email?.message}
          />
          <TextField
            id='password'
            autoComplete='new-password'
            type='password'
            name='password'
            {...register('password')}
            required
            fullWidth
            margin='normal'
            label='Password'
            error={errors.password ? true : false}
            helperText={errors.password?.message}
          />
          <LoadingButton
            size='large'
            type='submit'
            fullWidth
            variant='contained'
            loading={loading}
            loadingPosition="start"
            startIcon={<LoginIcon />}
            sx={{ mt: 4, mb: 4 }}
          >
            Log in
          </LoadingButton>
        </Box>
        <Link
          component={NavLink}
          to={'/forgot-password'}
          variant="body1"
          sx={{
            mt: 2,
            mb: 2
          }}
        >
          {`Forgot your password?`}
        </Link>
        <Link
          component={NavLink}
          to={'/request-verification'}
          variant="body1"
          sx={{
            mt: 2,
            mb: 2
          }}
        >
          {`Verify your account`}
        </Link>
        <Link
          component={NavLink}
          to={'/register'}
          variant="body1"
          sx={{
            mt: 2,
            mb: 2
          }}
        >
          {`Don't have an account? Register`}
        </Link>
      </Box>
    </Container>
  )
}

